import Card from './lib/card';
import CardHeader from './lib/header';
import CardContent from './lib/content';

Card.CardHeader = CardHeader;
Card.CardContent = CardContent;

export default Card;
